import { createForm, Validations, findElementById, getTranslation } from '../Utils';

declare const grecaptcha: any;

interface ContactFormResponse {
    errorMessage?: string;
}

interface ContactFormRequest {
    link: string;
    header: string;
    email: string;
    description: string;
    recaptchaToken?: string; // Lägg till detta fält
}

/*
 * Helper function for toggling hidden class
 */
export function registerContactFormBlock(): void {

    /***********************************************************/
    /**                 reCAPTCHA control                     **/
    /***********************************************************/
    function successCallback(token: string) {
        console.log("grecaptcha succeeded!");

        // Sätt värdet på RecaptchaResponse-elementet
        const recaptchaTokenElement = document.getElementById('RecaptchaToken');
        if (recaptchaTokenElement) {
            recaptchaTokenElement.innerText = token; // Eller innerHTML om det behövs
        }
    }
    function onRecaptchaCallback(siteKey: string) {
        console.log("reCAPTCHA is ready!");
        grecaptcha.render('divRecaptcha', {
            'sitekey': siteKey,
            'callback': successCallback
        });
    };

    // Hämta nonce från servern om den är tillgänglig

    // get the CSP nonce as the nonce attribute of the script elemeent
    //var cspNonce = document.querySelector('[nonce]') ? document.querySelector('[nonce]').nonce || document.querySelector('[nonce]').getAttribute('nonce') : '';

    var cspNonce = '';
    const nonceElement = document.querySelector('[nonce]');
    if (nonceElement) {
        // Säkerställ att elementet inte är null innan du använder .nonce eller .getAttribute
        /*cspNonce = nonceElement.nonce || nonceElement.getAttribute('nonce') || '';*/


        // Kontrollera om elementet är ett HTMLScriptElement eller HTMLStyleElement
        if (nonceElement && (nonceElement instanceof HTMLScriptElement || nonceElement instanceof HTMLStyleElement)) {
            cspNonce = nonceElement.nonce || nonceElement.getAttribute('nonce') || '';
        }
    }

    // Fetch the SiteKey from the server
    fetch('/umbraco/api/mail/GetRecaptchaSiteKey')
        .then(response => response.text())
        .then(siteKey => {

            console.log("Succeeded in feteching reCaptcha sitekey");

            // Make the function available in the global scope
            (window as any).onRecaptchaCallback = () => onRecaptchaCallback(siteKey);

            // Load the reCAPTCHA script
            const script = document.createElement('script');
            script.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaCallback&render=explicit";
            script.async = true;
            script.defer = true;

            if (!cspNonce) {
                console.error('CSP nonce not found');
            } else {
                console.log('CSP nonce:', cspNonce);
                script.setAttribute('nonce', cspNonce);
            }

            document.head.appendChild(script);
        })
        .catch(error => console.error('Error fetching SiteKey:', error));



    const VALIDATIONS: Validations = {
        departmentId: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
            validations: [
                {
                    message: getTranslation('contactForm.department'),
                    pattern: /^\d+$/g
                },
            ],
        },
        activityAreaId: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
            validations: [
                {
                    message: getTranslation('contactForm.activityArea'),
                    pattern: /^\d+$/g
                },
            ],
        },
        firstName: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
        },
        lastName: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
        },
        company: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
        },
        city: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
        },
        email: {
            message: getTranslation('contactForm.requiredField'),
            required: true,
            validations: [
                {
                    pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                    message: getTranslation('contactForm.emailField'),
                }
            ],
        },
    };

    const $form = findElementById<HTMLFormElement>('contactForm');
    const $formSpinner = findElementById('contactFormSpinner');

    // Missing target elements -> Early exit
    if (!$form) {
        return;
    }

    // Initialize form binding
    if ($form) {
        createForm<ContactFormResponse, ContactFormRequest>($form, {
            validations: VALIDATIONS,
            submit(data) {

                // Get the reCAPTCHA token
                const recaptchaToken = grecaptcha.getResponse();

                //// If reCAPTCHA is not completed, display a message and cancel the submit
                //if (!recaptchaToken) {
                //    console.log("Please complete the reCAPTCHA.");
                //    return false;
                //}

                // Add the reCAPTCHA token to the data being sent to the API
                data.recaptchaToken = recaptchaToken;

                // Show the spinner to indicate that a request is in progress
                $formSpinner?.classList.remove('hidden');
            },
            success(res) {
                // Hide the spinner
                $formSpinner?.classList.add('hidden');

                return getTranslation('contactForm.successMessage')!;
            },
            error(res, ex) {
                console.error('Request failed', res?.errorMessage ?? ex);
                $formSpinner?.classList.add('hidden');

                return res?.errorMessage ?? ex?.message;
            }
        });
    }
}
